import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "../../api/axios";

const MESES = [
  "ENERO", "FEBRERO", "MARZO", "ABRIL", "MAYO", "JUNIO",
  "JULIO", "AGOSTO", "SEPTIEMBRE", "OCTUBRE", "NOVIEMBRE", "DICIEMBRE"
];

export default function GestionCuotas() {
  const navigate = useNavigate();
  const [alerta, setAlerta] = useState({ mostrar: false, mensaje: "", tipo: "success" });

  const [socios, setSocios] = useState([]);
  const [cuotas, setCuotas] = useState([]);
  const [convenios, setConvenios] = useState([]);
  const [loadingSocios, setLoadingSocios] = useState(true);
  // Añade estos estados nuevos (junto a los otros modales)
const [modalEliminarConvenio, setModalEliminarConvenio] = useState(false);
const [convenioAEliminar, setConvenioAEliminar] = useState(null); // {id, nombre, valor}

// ── Estado modal eliminar cuota ────────────────────────────────
const [modalEliminarCuota, setModalEliminarCuota] = useState(false);
const [cuotaAEliminar, setCuotaAEliminar] = useState(null); // {id, nombre, valor}

  const [busqueda, setBusqueda] = useState("");
  const [socioSeleccionado, setSocioSeleccionado] = useState(null);

  const [cuotaSeleccionada, setCuotaSeleccionada] = useState("");
  const [valorCuota, setValorCuota] = useState("");

  const [convenioSeleccionado, setConvenioSeleccionado] = useState("");
  const [valorConvenio, setValorConvenio] = useState("");
  const [fechaConvenio, setFechaConvenio] = useState("");
  const [filtroFacultad, setFiltroFacultad] = useState("TODAS");
  const [filtroTipoSocio, setFiltroTipoSocio] = useState("TODOS");

  const [mes, setMes] = useState("ENERO");
  const [anio, setAnio] = useState(new Date().getFullYear());

  const [sociosConRegistro, setSociosConRegistro] = useState(new Set());
  const [resumen, setResumen] = useState(null);

  // ── Estado modal edición convenio ──────────────────────────────
  const [modalEditar, setModalEditar] = useState(false);
  const [convenioEditando, setConvenioEditando] = useState(null); // { id, convenio_id, valor, fecha }
  const [editConvenioId, setEditConvenioId] = useState("");
  const [editValor, setEditValor] = useState("");
  const [editFecha, setEditFecha] = useState("");
  const [guardandoEdicion, setGuardandoEdicion] = useState(false);

  // ── Estado modal edición CUOTA ──────────────────────────────────
  const [modalEditarCuota, setModalEditarCuota] = useState(false);
  const [cuotaEditando, setCuotaEditando] = useState(null); // { id, cuota_id, nombre, valor }
  const [editCuotaId, setEditCuotaId] = useState("");
  const [editValorCuota, setEditValorCuota] = useState("");
  const [guardandoEdicionCuota, setGuardandoEdicionCuota] = useState(false);

  // ── Estado modal cuotas fijas ───────────────────────────────────
  const [modalCuotasFijas, setModalCuotasFijas] = useState(false);
  const [generandoFijas, setGenerandoFijas] = useState(false);

  // ───────────────────────────────────────────────────────────────

  useEffect(() => {
    const init = async () => {
      setLoadingSocios(true);
      await Promise.all([cargarSocios(), cargarCuotas(), cargarConvenios()]);
      setLoadingSocios(false);
    };
    init();
  }, []);

  useEffect(() => {
    const cargar = async () => {
      try {
        const response = await axios.get("/meses-registrados", { params: { mes, anio } });
        if (response.data.ok) setSociosConRegistro(new Set(response.data.socios || []));
      } catch (err) {
        console.error("Error al cargar meses registrados:", err);
      }
    };
    cargar();
  }, [mes, anio]);

  const cargarSocios = async () => {
    try {
      const response = await axios.get("/socios");
      setSocios(response.data.socios || []);
    } catch (error) {
      console.error("Error cargando socios:", error);
      setSocios([]);
    }
  };

  const cargarCuotas = async () => {
    try {
      const response = await axios.get("/cuotas");
      setCuotas(response.data.cuotas || []);
    } catch (error) {
      console.error("Error cargando cuotas:", error);
    }
  };

  const cargarConvenios = async () => {
    try {
      const response = await axios.get("/convenios");
      setConvenios(response.data.convenios || []);
    } catch (error) {
      console.error("Error cargando convenios:", error);
    }
  };

  const cargarResumen = async (socio) => {
    try {
      const response = await axios.get("/total-mensual", { params: { usuario_id: socio.id } });
      setResumen(response.data);
    } catch (error) {
      console.error("Error al cargar resumen:", error);
      setResumen(null);
    }
  };

  const recargarRegistrosDelMes = async () => {
    try {
      const response = await axios.get("/meses-registrados", { params: { mes, anio } });
      if (response.data.ok) setSociosConRegistro(new Set(response.data.socios || []));
    } catch (err) {
      console.error("Error al cargar meses registrados:", err);
    }
  };

  const exportarExcel = async () => {
    try {
      const response = await axios.get("/resumen-mensual/excel", {
        params: { mes, anio },
        responseType: "blob"
      });
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", `Resumen_${mes}_${anio}.xlsx`);
      document.body.appendChild(link);
      link.click();
      link.remove();
    } catch (error) {
      console.error("Error exportando Excel:", error);
      mostrarAlerta("No se pudo generar el Excel", "danger");
    }
  };

  const registrarCuota = async () => {
    if (!socioSeleccionado || !cuotaSeleccionada || !valorCuota) {
      mostrarAlerta("Complete los campos requeridos para la cuota", "danger");
      return;
    }
    try {
      await axios.post("/cuotas/registrar", {
        usuario_id: socioSeleccionado.id,
        cuota_id: cuotaSeleccionada,
        mes,
        anio,
        valor: Number(valorCuota)
      });
      mostrarAlerta("Cuota registrada correctamente");
      setCuotaSeleccionada("");
      setValorCuota("");
      setSociosConRegistro(prev => new Set([...prev, socioSeleccionado.id]));
      // Refrescamos el histórico para que se vea la nueva cuota de inmediato
      await cargarResumen(socioSeleccionado);
    } catch (error) {
      console.error("Error al registrar cuota:", error);
      mostrarAlerta(error.response?.data?.msg || "Error al registrar cuota", "danger");
    }
  };

  const registrarConvenio = async () => {
    if (!socioSeleccionado || !convenioSeleccionado || !valorConvenio) {
      mostrarAlerta("Complete los campos requeridos para el convenio", "danger");
      return;
    }
    try {
      const payload = {
        usuario_id: socioSeleccionado.id,
        convenio_id: convenioSeleccionado,
        valor: Number(valorConvenio)
      };
      if (fechaConvenio) payload.fecha = fechaConvenio;

      await axios.post("/uso-convenios", payload);
      mostrarAlerta("Convenio registrado correctamente");
      setConvenioSeleccionado("");
      setValorConvenio("");
      setFechaConvenio("");
      setSociosConRegistro(prev => new Set([...prev, socioSeleccionado.id]));
    } catch (error) {
      console.error("Error al registrar convenio:", error);
      mostrarAlerta(error.response?.data?.msg || "Error al registrar convenio", "danger");
    }
  };

  // ── Editar Convenio ──────────────────────────────────────────────
  const abrirModalEditar = (descuento) => {
    setConvenioEditando(descuento);
    setEditConvenioId(descuento.convenio_id?.toString() || "");
    setEditValor(descuento.valor?.toString() || "");
    setEditFecha(descuento.fecha ? descuento.fecha.split("T")[0] : "");
    setModalEditar(true);
  };

  const cerrarModal = () => {
    setModalEditar(false);
    setConvenioEditando(null);
    setEditConvenioId("");
    setEditValor("");
    setEditFecha("");
  };

  const guardarEdicion = async () => {
    if (!editValor) {
      mostrarAlerta("El valor es obligatorio", "danger");
      return;
    }
    setGuardandoEdicion(true);
    try {
      const payload = {};
      if (editConvenioId) payload.convenio_id = Number(editConvenioId);
      if (editValor)      payload.valor        = Number(editValor);
      if (editFecha)      payload.fecha         = editFecha;

      await axios.put(`/uso-convenio/${convenioEditando.id}`, payload);

      mostrarAlerta("Convenio actualizado correctamente");
      cerrarModal();
      await cargarResumen(socioSeleccionado);
    } catch (error) {
      console.error("Error al editar convenio:", error);
      mostrarAlerta(error.response?.data?.message || "Error al editar convenio", "danger");
    } finally {
      setGuardandoEdicion(false);
    }
  };

  // ── Eliminar Convenio (con modal) ─────────────────────────────
const abrirModalEliminarConvenio = (descuento) => {
  setConvenioAEliminar(descuento);
  setModalEliminarConvenio(true);
};

const cerrarModalEliminarConvenio = () => {
  setModalEliminarConvenio(false);
  setConvenioAEliminar(null);
};

const confirmarEliminarConvenio = async () => {
  if (!convenioAEliminar) return;

  try {
    await axios.delete(`/uso-convenio/${convenioAEliminar.id}`);
    
    mostrarAlerta("Convenio eliminado correctamente", "success");
    await cargarResumen(socioSeleccionado);
    await recargarRegistrosDelMes();
    
    cerrarModalEliminarConvenio();
  } catch (error) {
    console.error("Error al eliminar convenio:", error);
    mostrarAlerta(error.response?.data?.message || "Error al eliminar el convenio", "danger");
  }
};
  // ───────────────────────────────────────────────────────────────

  // ── Editar CUOTA ─────────────────────────────────────────────────
  const abrirModalEditarCuota = (cuotaRegistro) => {
    // cuotaRegistro viene del histórico: { id, cuota_id, nombre, valor }
    setCuotaEditando(cuotaRegistro);
    setEditCuotaId(cuotaRegistro.cuota_id?.toString() || "");
    setEditValorCuota(cuotaRegistro.valor?.toString() || "");
    setModalEditarCuota(true);
  };

  const cerrarModalCuota = () => {
    setModalEditarCuota(false);
    setCuotaEditando(null);
    setEditCuotaId("");
    setEditValorCuota("");
  };

  const guardarEdicionCuota = async () => {
    if (!editCuotaId || !editValorCuota) {
      mostrarAlerta("Complete los campos requeridos", "danger");
      return;
    }
    setGuardandoEdicionCuota(true);
    try {
      await axios.put(`/cuotas/editar/${cuotaEditando.id}`, {
        usuario_id: socioSeleccionado.id,
        cuota_id: Number(editCuotaId),
        mes,
        anio,
        valor: Number(editValorCuota)
      });

      mostrarAlerta("Cuota actualizada correctamente");
      cerrarModalCuota();
      await cargarResumen(socioSeleccionado);
    } catch (error) {
      console.error("Error al editar cuota:", error);
      mostrarAlerta(error.response?.data?.message || "Error al editar cuota", "danger");
    } finally {
      setGuardandoEdicionCuota(false);
    }
  };

  // ── Eliminar Cuota (con modal) ─────────────────────────────────
const abrirModalEliminarCuota = (cuota) => {
  setCuotaAEliminar(cuota);
  setModalEliminarCuota(true);
};

const cerrarModalEliminarCuota = () => {
  setModalEliminarCuota(false);
  setCuotaAEliminar(null);
};

const confirmarEliminarCuota = async () => {
  if (!cuotaAEliminar) return;

  try {
    await axios.delete(`/cuotas/eliminar/${cuotaAEliminar.id}`);
    
    mostrarAlerta("Cuota eliminada correctamente", "success");
    await cargarResumen(socioSeleccionado);
    await recargarRegistrosDelMes();
    
    cerrarModalEliminarCuota();
  } catch (error) {
    console.error("Error al eliminar cuota:", error);
    mostrarAlerta(error.response?.data?.message || "Error al eliminar la cuota", "danger");
  }
};
  // ───────────────────────────────────────────────────────────────

  // ── Generar cuotas fijas (masivo) ───────────────────────────────
  const abrirModalCuotasFijas = () => {
    setModalCuotasFijas(true);
  };

  const cerrarModalCuotasFijas = () => {
    if (generandoFijas) return;
    setModalCuotasFijas(false);
  };

  const confirmarGenerarCuotasFijas = async () => {
    setGenerandoFijas(true);
    try {
      const response = await axios.post("/cuotas/registrarFijas", { mes, anio });
      const { socios_procesados, cuotas_generadas } = response.data || {};

      mostrarAlerta(
        `Cuotas fijas generadas: ${cuotas_generadas ?? 0} registro(s) para ${socios_procesados ?? 0} socio(s)`,
        "success"
      );

      setModalCuotasFijas(false);

      await recargarRegistrosDelMes();
      if (socioSeleccionado) {
        await cargarResumen(socioSeleccionado);
      }
    } catch (error) {
      console.error("Error al generar cuotas fijas:", error);
      mostrarAlerta(error.response?.data?.message || "Error al generar las cuotas fijas", "danger");
    } finally {
      setGenerandoFijas(false);
    }
  };
  // ───────────────────────────────────────────────────────────────

  const sociosFiltrados = socios.filter(socio => {
    if (!socio) return false;

    if (socio.rol === "SECRETARIA") return false;
    if (socio.estado === "INACTIVO") return false;

    const tipoSocioActual = socio.tipo_socio || "GENERAL";

    const texto = [
      socio.cedula || '',
      socio.nombres || '',
      socio.apellidos || '',
      socio.email || '',
      socio.facultad?.nombre || ''
    ].join(' ').toLowerCase();

    return (
      texto.includes(busqueda.toLowerCase().trim()) &&

      (filtroFacultad === "TODAS" ||
        socio.facultad?.nombre === filtroFacultad) &&

      (filtroTipoSocio === "TODOS" ||
        tipoSocioActual === filtroTipoSocio)
    );
  });

  const handleSeleccionarSocio = (socio) => {
    setSocioSeleccionado(socio);
    cargarResumen(socio);
    setCuotaSeleccionada("");
    setValorCuota("");
    setConvenioSeleccionado("");
    setValorConvenio("");
    setFechaConvenio("");
  };

  const badgeEstado = (estado) => {
    switch (estado) {
      case "ACTIVO":    return "bg-success-subtle text-success border border-success-subtle";
      case "PENDIENTE": return "bg-warning-subtle text-warning border border-warning-subtle";
      case "INACTIVO":  return "bg-secondary-subtle text-secondary border border-secondary-subtle";
      default:          return "bg-secondary-subtle text-secondary border border-secondary-subtle";
    }
  };

  const mostrarAlerta = (mensaje, tipo = "success") => {
    setAlerta({ mostrar: true, mensaje, tipo });
    setTimeout(() => setAlerta({ mostrar: false, mensaje: "", tipo: "success" }), 3000);
  };

  return (
    <div className="container-fluid bg-light min-vh-100 py-4 px-3 px-lg-5">

      {/* Alerta flotante */}
      {alerta.mostrar && (
        <div
          className={`alert alert-${alerta.tipo} alert-dismissible fade show shadow position-fixed`}
          style={{ top: "20px", right: "20px", zIndex: 9999, minWidth: "320px" }}
        >
          <div className="d-flex align-items-center">
            <i className={`bi me-2 ${
              alerta.tipo === "success" ? "bi-check-circle-fill" :
              alerta.tipo === "danger"  ? "bi-x-circle-fill" : "bi-info-circle-fill"
            }`}></i>
            <span>{alerta.mensaje}</span>
          </div>
          <button className="btn-close" onClick={() => setAlerta({ ...alerta, mostrar: false })}></button>
        </div>
      )}

      {/* ── Modal Editar Convenio ─────────────────────────────────── */}
      {modalEditar && (
        <>
          <div
            className="modal-backdrop fade show"
            style={{ zIndex: 1040 }}
            onClick={cerrarModal}
          />
          <div
            className="modal fade show d-block"
            style={{ zIndex: 1050 }}
            tabIndex="-1"
          >
            <div className="modal-dialog modal-dialog-centered">
              <div className="modal-content border-0 shadow-lg">
                <div className="modal-header border-0 pb-0">
                  <h5 className="modal-title fw-bold">
                    <i className="bi bi-pencil-square text-success me-2"></i>
                    Editar Convenio
                  </h5>
                  <button className="btn-close" onClick={cerrarModal}></button>
                </div>

                <div className="modal-body pt-3">
                  <div className="mb-3">
                    <label className="form-label fw-semibold small text-muted">Convenio</label>
                    <select
                      className="form-select"
                      value={editConvenioId}
                      onChange={e => setEditConvenioId(e.target.value)}
                    >
                      <option value="">Sin cambiar</option>
                      {convenios.map(c => (
                        <option key={c.id} value={c.id}>{c.nombre}</option>
                      ))}
                    </select>
                  </div>

                  <div className="mb-3">
                    <label className="form-label fw-semibold small text-muted">Valor</label>
                    <div className="input-group">
                      <span className="input-group-text">$</span>
                      <input
                        type="number"
                        className="form-control"
                        value={editValor}
                        onChange={e => setEditValor(e.target.value)}
                        placeholder="0.00"
                      />
                    </div>
                  </div>

                  <div className="mb-1">
                    <label className="form-label fw-semibold small text-muted">
                      Fecha <span className="text-muted fw-normal">(opcional)</span>
                    </label>
                    <input
                      type="date"
                      className="form-control"
                      value={editFecha}
                      onChange={e => setEditFecha(e.target.value)}
                    />
                    <div className="form-text text-warning">
                      <i className="bi bi-exclamation-triangle me-1"></i>
                      Cambiar la fecha puede mover este descuento a otro mes en el histórico.
                    </div>
                  </div>
                </div>

                <div className="modal-footer border-0 pt-0">
                  <button
                    className="btn btn-outline-secondary"
                    onClick={cerrarModal}
                    disabled={guardandoEdicion}
                  >
                    Cancelar
                  </button>
                  <button
                    className="btn btn-success"
                    onClick={guardarEdicion}
                    disabled={guardandoEdicion || !editValor}
                  >
                    {guardandoEdicion
                      ? <><span className="spinner-border spinner-border-sm me-2"></span>Guardando...</>
                      : <><i className="bi bi-check-lg me-1"></i>Guardar cambios</>
                    }
                  </button>
                </div>
              </div>
            </div>
          </div>
        </>
      )}
      {/* ─────────────────────────────────────────────────────────── */}

      {/* ── Modal Editar Cuota ───────────────────────────────────────── */}
      {modalEditarCuota && (
        <>
          <div
            className="modal-backdrop fade show"
            style={{ zIndex: 1040 }}
            onClick={cerrarModalCuota}
          />
          <div
            className="modal fade show d-block"
            style={{ zIndex: 1050 }}
            tabIndex="-1"
          >
            <div className="modal-dialog modal-dialog-centered">
              <div className="modal-content border-0 shadow-lg">
                <div className="modal-header border-0 pb-0">
                  <h5 className="modal-title fw-bold">
                    <i className="bi bi-pencil-square text-success me-2"></i>
                    Editar Cuota
                  </h5>
                  <button className="btn-close" onClick={cerrarModalCuota}></button>
                </div>

                <div className="modal-body pt-3">
                  <div className="mb-3">
                    <label className="form-label fw-semibold small text-muted">Cuota</label>
                    <select
                      className="form-select"
                      value={editCuotaId}
                      onChange={e => setEditCuotaId(e.target.value)}
                    >
                      <option value="">Seleccione cuota</option>
                      {cuotas.map(c => (
                        <option key={c.id} value={c.id}>{c.nombre}</option>
                      ))}
                    </select>
                  </div>

                  <div className="mb-1">
                    <label className="form-label fw-semibold small text-muted">Valor</label>
                    <div className="input-group">
                      <span className="input-group-text">$</span>
                      <input
                        type="number"
                        className="form-control"
                        value={editValorCuota}
                        onChange={e => setEditValorCuota(e.target.value)}
                        placeholder="0.00"
                      />
                    </div>
                  </div>

                  <div className="form-text text-muted mt-2">
                    Esta edición actualiza el registro de <strong>{mes} {anio}</strong> para este socio.
                  </div>
                </div>

                <div className="modal-footer border-0 pt-0">
                  <button
                    className="btn btn-outline-secondary"
                    onClick={cerrarModalCuota}
                    disabled={guardandoEdicionCuota}
                  >
                    Cancelar
                  </button>
                  <button
                    className="btn btn-success"
                    onClick={guardarEdicionCuota}
                    disabled={guardandoEdicionCuota || !editCuotaId || !editValorCuota}
                  >
                    {guardandoEdicionCuota
                      ? <><span className="spinner-border spinner-border-sm me-2"></span>Guardando...</>
                      : <><i className="bi bi-check-lg me-1"></i>Guardar cambios</>
                    }
                  </button>
                </div>
              </div>
            </div>
          </div>
        </>
      )}
      {/* ─────────────────────────────────────────────────────────── */}

      {/* ── Modal Generar Cuotas Fijas ────────────────────────────── */}
      {modalCuotasFijas && (
        <>
          <div
            className="modal-backdrop fade show"
            style={{ zIndex: 1040 }}
            onClick={cerrarModalCuotasFijas}
          />
          <div
            className="modal fade show d-block"
            style={{ zIndex: 1050 }}
            tabIndex="-1"
          >
            <div className="modal-dialog modal-dialog-centered">
              <div className="modal-content border-0 shadow-lg">
                <div className="modal-header border-0 pb-0">
                  <h5 className="modal-title fw-bold">
                    <i className="bi bi-stars text-success me-2"></i>
                    Generar Cuotas Fijas
                  </h5>
                  <button
                    className="btn-close"
                    onClick={cerrarModalCuotasFijas}
                    disabled={generandoFijas}
                  ></button>
                </div>

                <div className="modal-body pt-3">
                  <p className="mb-3">
                    Esto generará automáticamente las cuotas fijas a todos los socios
                    excluyendo empleados.
                  </p>

                  <div className="alert alert-info-subtle border border-info-subtle py-2 px-3 mb-3">
                    <div className="d-flex justify-content-between small">
                      <span className="text-muted">Mes seleccionado:</span>
                      <span className="fw-semibold">{mes}</span>
                    </div>
                    <div className="d-flex justify-content-between small">
                      <span className="text-muted">Año seleccionado:</span>
                      <span className="fw-semibold">{anio}</span>
                    </div>
                  </div>

                  <div className="text-warning small">
                    <i className="bi bi-exclamation-triangle me-1"></i>
                    Si un socio ya tiene alguna de estas cuotas registrada en este mes,
                    no se duplicará; solo se crearán las que falten.
                  </div>
                </div>

                <div className="modal-footer border-0 pt-0">
                  <button
                    className="btn btn-outline-secondary"
                    onClick={cerrarModalCuotasFijas}
                    disabled={generandoFijas}
                  >
                    Cancelar
                  </button>
                  <button
                    className="btn btn-success"
                    onClick={confirmarGenerarCuotasFijas}
                    disabled={generandoFijas}
                  >
                    {generandoFijas
                      ? <><span className="spinner-border spinner-border-sm me-2"></span>Generando...</>
                      : <><i className="bi bi-check-lg me-1"></i>Sí, generar</>
                    }
                  </button>
                </div>
              </div>
            </div>
          </div>
        </>
      )}

      {/* ── Modal Confirmar Eliminar Cuota ───────────────────────────── */}
{modalEliminarCuota && cuotaAEliminar && (
  <>
    <div className="modal-backdrop fade show" style={{ zIndex: 1040 }} onClick={cerrarModalEliminarCuota} />
    <div className="modal fade show d-block" style={{ zIndex: 1050 }} tabIndex="-1">
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content border-0 shadow-lg">
          <div className="modal-header border-0 pb-0">
            <h5 className="modal-title fw-bold text-danger">
              <i className="bi bi-trash3 me-2"></i>
              Eliminar Cuota
            </h5>
            <button className="btn-close" onClick={cerrarModalEliminarCuota}></button>
          </div>

          <div className="modal-body py-4">
            <div className="text-center mb-4">
              <div className="mx-auto bg-danger-subtle rounded-circle d-inline-flex align-items-center justify-content-center mb-3" style={{ width: "70px", height: "70px" }}>
                <i className="bi bi-exclamation-triangle text-danger fs-1"></i>
              </div>
              <h6>¿Estás seguro de eliminar esta cuota?</h6>
            </div>

            <div className="border rounded-3 p-3 bg-light">
              <div className="d-flex justify-content-between align-items-center">
                <strong>{cuotaAEliminar.nombre}</strong>
                <span className="fw-bold text-success fs-5">${cuotaAEliminar.valor}</span>
              </div>
            </div>

            <p className="text-muted small mt-3 text-center">
              Esta acción no se puede deshacer.
            </p>
          </div>

          <div className="modal-footer border-0">
            <button
              className="btn btn-outline-secondary px-4"
              onClick={cerrarModalEliminarCuota}
            >
              Cancelar
            </button>
            <button
              className="btn btn-danger px-4"
              onClick={confirmarEliminarCuota}
            >
              <i className="bi bi-trash me-2"></i>
              Sí, Eliminar
            </button>
          </div>
        </div>
      </div>
    </div>
  </>
)}

      {/* ── Modal Confirmar Eliminar Convenio ───────────────────────────── */}
{modalEliminarConvenio && convenioAEliminar && (
  <>
    <div className="modal-backdrop fade show" style={{ zIndex: 1040 }} onClick={cerrarModalEliminarConvenio} />
    <div className="modal fade show d-block" style={{ zIndex: 1050 }} tabIndex="-1">
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content border-0 shadow-lg">
          <div className="modal-header border-0 pb-0">
            <h5 className="modal-title fw-bold text-danger">
              <i className="bi bi-trash3 me-2"></i>
              Eliminar Convenio
            </h5>
            <button className="btn-close" onClick={cerrarModalEliminarConvenio}></button>
          </div>

          <div className="modal-body py-4">
            <div className="text-center mb-4">
              <div className="mx-auto bg-danger-subtle rounded-circle d-inline-flex align-items-center justify-content-center mb-3" style={{ width: "70px", height: "70px" }}>
                <i className="bi bi-exclamation-triangle text-danger fs-1"></i>
              </div>
              <h6>¿Estás seguro de eliminar este convenio?</h6>
            </div>

            <div className="border rounded-3 p-3 bg-light">
              <div className="d-flex justify-content-between align-items-center">
                <div>
                  <strong>{convenioAEliminar.nombre}</strong>
                  {convenioAEliminar.fecha && (
                    <div className="small text-muted">
                      {new Date(convenioAEliminar.fecha).toLocaleDateString("es-EC")}
                    </div>
                  )}
                </div>
                <span className="fw-bold text-info fs-5">-${convenioAEliminar.valor}</span>
              </div>
            </div>

            <p className="text-muted small mt-3 text-center">
              Esta acción no se puede deshacer.
            </p>
          </div>

          <div className="modal-footer border-0">
            <button
              className="btn btn-outline-secondary px-4"
              onClick={cerrarModalEliminarConvenio}
            >
              Cancelar
            </button>
            <button
              className="btn btn-danger px-4"
              onClick={confirmarEliminarConvenio}
            >
              <i className="bi bi-trash me-2"></i>
              Sí, Eliminar
            </button>
          </div>
        </div>
      </div>
    </div>
  </>
)}
      {/* ─────────────────────────────────────────────────────────── */}

      {/* Header */}
      <div className="card shadow border-0 mb-4 border-start border-4 border-success">
        <div className="card-body">
          <div className="d-flex flex-wrap justify-content-between align-items-center gap-3">
            <div className="d-flex align-items-center gap-3">
              <button
                className="btn btn-outline-success rounded-circle p-2 border-0 shadow-sm"
                onClick={() => navigate("/DashboardSecretaria")}
              >
                <i className="bi bi-arrow-left fs-4"></i>
              </button>
              <h4 className="fw-bold text-success mb-0">
                <i className="bi bi-wallet2 me-2"></i>
                Gestión de Cuotas y Convenios
              </h4>
            </div>
            <div className="d-flex gap-3 align-items-end flex-wrap">

              <div>
                <label className="form-label small fw-bold text-muted text-uppercase mb-1">
                  Mes
                </label>
                <select
                  className="form-select form-select-sm shadow-sm"
                  value={mes}
                  onChange={(e) => setMes(e.target.value)}
                >
                  {MESES.map(m => (
                    <option key={m} value={m}>
                      {m}
                    </option>
                  ))}
                </select>
              </div>

              <div>
                <label className="form-label small fw-bold text-muted text-uppercase mb-1">
                  Año
                </label>
                <input
                  type="number"
                  className="form-control form-control-sm shadow-sm"
                  style={{ width: "100px" }}
                  value={anio}
                  onChange={(e) => setAnio(Number(e.target.value))}
                />
              </div>

              <div>
                <button
                  className="btn btn-outline-success btn-sm shadow-sm"
                  onClick={abrirModalCuotasFijas}
                >
                  <i className="bi bi-pin-angle me-2"></i>
                  Cuotas Fijas
                </button>
              </div>

              <div>
                <button
                  className="btn btn-success btn-sm shadow-sm"
                  onClick={exportarExcel}
                >
                  <i className="bi bi-file-earmark-excel me-2"></i>
                  Excel
                </button>
              </div>

            </div>
          </div>
        </div>
      </div>

      <div className="row g-4">
        {/* Listado de socios */}
        <div className="col-lg-7">
          <div className="card shadow border-0 h-100">
            <div className="card-header bg-white">
              <div className="row g-3 align-items-end">

                <div className="col-md-6">
                  <label className="form-label small fw-bold text-muted text-uppercase">
                    Búsqueda rápida
                  </label>
                  <div className="input-group">
                    <span className="input-group-text bg-white border-end-0 text-muted">
                      <i className="bi bi-search"></i>
                    </span>
                    <input
                      className="form-control border-start-0 ps-0 shadow-none"
                      placeholder="Cédula, nombres o apellidos..."
                      value={busqueda}
                      onChange={(e) => setBusqueda(e.target.value)}
                    />
                  </div>
                </div>

                <div className="col-md-3">
                  <label className="form-label small fw-bold text-muted text-uppercase">
                    Facultad
                  </label>
                  <select
                    className="form-select shadow-none"
                    value={filtroFacultad}
                    onChange={(e) => setFiltroFacultad(e.target.value)}
                  >
                    <option value="TODAS">Todas</option>
                    {[
                      ...new Set(
                        socios
                          .filter(s => s.facultad?.nombre)
                          .map(s => s.facultad.nombre)
                      )
                    ].map((fac, i) => (
                      <option key={i} value={fac}>
                        {fac}
                      </option>
                    ))}
                  </select>
                </div>

                <div className="col-md-3">
                  <label className="form-label small fw-bold text-muted text-uppercase">
                    Tipo Socio
                  </label>
                  <select
                    className="form-select shadow-none"
                    value={filtroTipoSocio}
                    onChange={(e) => setFiltroTipoSocio(e.target.value)}
                  >
                    <option value="TODOS">Todos</option>
                    <option value="GENERAL">General</option>
                    <option value="JUBILADO">Jubilado</option>
                    <option value="JUBILADO B">Jubilado B</option>
                  </select>
                </div>

              </div>
            </div>

            <div className="card-body p-0">
              {loadingSocios ? (
                <div className="text-center py-5">
                  <div className="spinner-border text-success" role="status"></div>
                  <p className="mt-2 text-muted">Cargando socios...</p>
                </div>
              ) : sociosFiltrados.length === 0 ? (
                <div className="text-center py-5 text-muted">
                  <i className="bi bi-people display-4 opacity-50 mb-3 d-block"></i>
                  {busqueda.trim()
                    ? `No hay coincidencias con "${busqueda}"`
                    : "No hay socios activos"}
                </div>
              ) : (
                <div className="table-responsive" style={{ maxHeight: '68vh' }}>
                  <table className="table table-hover table-sm mb-0 align-middle">
                    <thead className="table-light text-uppercase text-muted small sticky-top">
                      <tr>
                        <th className="ps-3">Socio</th>
                        <th>Facultad</th>
                      </tr>
                    </thead>
                    <tbody>
                      {sociosFiltrados.map(socio => {
                        const tieneRegistro = sociosConRegistro.has(socio.id);
                        const seleccionado  = socioSeleccionado?.id === socio.id;
                        let rowClass = "cursor-pointer";
                        if (seleccionado)   rowClass += " table-primary fw-semibold";
                        else if (tieneRegistro) rowClass += " table-success";

                        return (
                          <tr
                            key={socio.id}
                            className={rowClass}
                            onClick={() => handleSeleccionarSocio(socio)}
                            style={{ cursor: "pointer" }}
                          >
                            <td className="ps-3">
                              <div>{socio.nombres} {socio.apellidos}</div>
                              <div className="small text-muted">{socio.cedula || 'Sin cédula'}</div>
                            </td>
                            <td className="small text-secondary">
                              {socio.facultad?.nombre || "—"}
                            </td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>
                </div>
              )}
            </div>
          </div>
        </div>

        {/* Panel derecho */}
        <div className="col-lg-5">
          {!socioSeleccionado ? (
            <div className="card h-100 border-0 shadow text-center d-flex align-items-center justify-content-center bg-white p-5">
              <i className="bi bi-person-plus display-1 text-success opacity-50 mb-4"></i>
              <h5 className="text-muted mb-2">Selecciona un socio</h5>
              <p className="text-muted small">Haz clic en cualquier fila de la tabla</p>
            </div>
          ) : (
            <div className="d-flex flex-column gap-4">
              <div className="card border-0 shadow">
                <div className="card-body">
                  <div className="d-flex align-items-center mb-4">
                    <div className="bg-success-subtle rounded-circle p-3 me-3">
                      <i className="bi bi-person-fill text-success fs-4"></i>
                    </div>
                    <div>
                      <h5 className="mb-1 fw-bold">
                        {socioSeleccionado.nombres} {socioSeleccionado.apellidos}
                      </h5>
                      <span className="badge bg-secondary">
                        {socioSeleccionado.cedula || 'Sin cédula'}
                      </span>
                    </div>
                  </div>

                  {/* Registro Cuota */}
                  <div className="mb-4">
                    <h6 className="fw-bold text-success mb-3">
                      <i className="bi bi-plus-circle me-2"></i> Registrar Cuota
                    </h6>
                    <div className="row g-2">
                      <div className="col-7">
                        <select
                          className="form-select border-success-subtle"
                          value={cuotaSeleccionada}
                          onChange={e => {
                            const id = e.target.value;
                            setCuotaSeleccionada(id);
                            const cuota = cuotas.find(c => c.id === Number(id));
                            setValorCuota(cuota?.valor?.toString() || "");
                          }}
                        >
                          <option value="">Seleccione cuota</option>
                          {cuotas.map(c => <option key={c.id} value={c.id}>{c.nombre}</option>)}
                        </select>
                      </div>
                      <div className="col-5">
                        <div className="input-group input-group-sm">
                          <span className="input-group-text">$</span>
                          <input
                            type="number"
                            className="form-control"
                            placeholder="0.00"
                            value={valorCuota}
                            onChange={e => setValorCuota(e.target.value)}
                          />
                        </div>
                      </div>
                    </div>
                    <button
                      className="btn btn-success w-100 mt-3"
                      onClick={registrarCuota}
                      disabled={!cuotaSeleccionada || !valorCuota}
                    >
                      <i className="bi bi-check-circle me-2"></i>
                      Guardar Cuota
                    </button>
                  </div>

                  {/* Registro Convenio */}
                  <div>
                    <h6 className="fw-bold text-success mb-3">
                      <i className="bi bi-tags me-2"></i> Registrar Convenio
                    </h6>
                    <div className="row g-2">
                      <div className="col-md-7">
                        <select
                          className="form-select border-success-subtle"
                          value={convenioSeleccionado}
                          onChange={e => setConvenioSeleccionado(e.target.value)}
                        >
                          <option value="">Seleccione convenio</option>
                          {convenios.map(c => <option key={c.id} value={c.id}>{c.nombre}</option>)}
                        </select>
                      </div>
                      <div className="col-md-5">
                        <div className="input-group input-group-sm">
                          <span className="input-group-text">$</span>
                          <input
                            type="number"
                            className="form-control"
                            placeholder="0.00"
                            value={valorConvenio}
                            onChange={e => setValorConvenio(e.target.value)}
                          />
                        </div>
                      </div>
                      <div className="col-12 mt-2">
                        <label className="form-label small text-muted mb-1">Fecha (opcional)</label>
                        <input
                          type="date"
                          className="form-control form-control-sm"
                          value={fechaConvenio}
                          onChange={e => setFechaConvenio(e.target.value)}
                        />
                      </div>
                    </div>
                    <button
                      className="btn btn-success w-100 mt-3"
                      onClick={registrarConvenio}
                      disabled={!convenioSeleccionado || !valorConvenio}
                    >
                      <i className="bi bi-check-circle me-2"></i>
                      Guardar Convenio
                    </button>
                  </div>
                </div>
              </div>

              {/* Histórico */}
              {resumen && (
                <div className="card border-0 shadow border-top border-4 border-success">
                  <div className="card-header bg-white">
                    <h6 className="mb-0 fw-bold text-dark">
                      <i className="bi bi-clock-history me-2 text-success"></i>
                      Histórico de este socio
                    </h6>
                  </div>
                  <div className="card-body p-0">
                    {resumen.meses?.length > 0 ? (
                      <div className="accordion accordion-flush" id="acordeonMeses">
                        {resumen.meses.map((m, i) => (
                          <div className="accordion-item" key={i}>
                            <h2 className="accordion-header">
                              <button
                                className="accordion-button collapsed py-3 px-4"
                                type="button"
                                data-bs-toggle="collapse"
                                data-bs-target={`#mes-${i}`}
                              >
                                <div className="d-flex w-100 justify-content-between align-items-center pe-2">
                                  <span className="fw-semibold">{m.mes} {m.anio}</span>
                                  <div className="d-flex gap-2 align-items-center">
                                    <span className="badge bg-success-subtle text-success border border-success-subtle small">
                                      Cuotas ${m.total_cuotas || 0}
                                    </span>
                                    <span className="badge bg-info-subtle text-info border border-info-subtle small">
                                      Desc ${m.total_descuentos || 0}
                                    </span>
                                    <span className="badge bg-success fs-6 px-2 py-1">
                                      ${m.total || 0}
                                    </span>
                                  </div>
                                </div>
                              </button>
                            </h2>

                            <div id={`mes-${i}`} className="accordion-collapse collapse">
                              <div className="accordion-body px-4 py-3">

                                {/* Cuotas del mes — con botones editar / eliminar */}
                                {m.detalles?.cuotas?.length > 0 && (
                                  <div className="mb-3">
                                    <p className="text-muted small fw-semibold text-uppercase mb-2">
                                      <i className="bi bi-wallet me-1"></i> Cuotas
                                    </p>
                                    {m.detalles.cuotas.map((c, j) => (
                                      <div key={j} className="d-flex justify-content-between align-items-center py-1 border-bottom gap-2">
                                        <span className="small">{c.nombre}</span>
                                        <div className="d-flex align-items-center gap-2">
                                          <span className="small fw-semibold text-success">${c.valor}</span>
                                          <button
                                            className="btn btn-outline-warning btn-sm py-0 px-2"
                                            style={{ fontSize: "0.75rem" }}
                                            title="Editar cuota"
                                            onClick={() => abrirModalEditarCuota({
                                              id: c.id,
                                              cuota_id: c.cuota_id,
                                              nombre: c.nombre,
                                              valor: c.valor
                                            })}
                                          >
                                            <i className="bi bi-pencil"></i>
                                          </button>
                                          <button
  className="btn btn-outline-danger btn-sm py-0 px-2"
  style={{ fontSize: "0.75rem" }}
  title="Eliminar cuota"
  onClick={() => abrirModalEliminarCuota({
    id: c.id,
    nombre: c.nombre,
    valor: c.valor
  })}
>
  <i className="bi bi-trash"></i>
</button>
                                        </div>
                                      </div>
                                    ))}
                                  </div>
                                )}

                                {/* Descuentos del mes — con botones editar / eliminar */}
                                {m.detalles?.descuentos?.length > 0 && (
                                  <div>
                                    <p className="text-muted small fw-semibold text-uppercase mb-2">
                                      <i className="bi bi-tags me-1"></i> Descuentos / Convenios
                                    </p>
                                    {m.detalles.descuentos.map((d, j) => (
                                      <div key={j} className="d-flex justify-content-between align-items-center py-1 border-bottom gap-2">
                                        <div className="small">
                                          <div>{d.nombre}</div>
                                          {d.fecha && (
                                            <div className="text-muted" style={{ fontSize: "0.75rem" }}>
                                              {new Date(d.fecha).toLocaleDateString("es-EC")}
                                            </div>
                                          )}
                                        </div>
                                        <div className="d-flex align-items-center gap-2">
                                          <span className="small fw-semibold text-info">${d.valor}</span>
                                          <button
                                            className="btn btn-outline-warning btn-sm py-0 px-2"
                                            style={{ fontSize: "0.75rem" }}
                                            title="Editar convenio"
                                            onClick={() => abrirModalEditar({
                                              id: d.id,
                                              convenio_id: d.convenio_id,
                                              nombre: d.nombre,
                                              valor: d.valor,
                                              fecha: d.fecha
                                            })}
                                          >
                                            <i className="bi bi-pencil"></i>
                                          </button>
                                          <button
  className="btn btn-outline-danger btn-sm py-0 px-2"
  style={{ fontSize: "0.75rem" }}
  title="Eliminar convenio"
  onClick={() => abrirModalEliminarConvenio({
    id: d.id,
    nombre: d.nombre,
    valor: d.valor,
    fecha: d.fecha
  })}
>
  <i className="bi bi-trash"></i>
</button>
                                        </div>
                                      </div>
                                    ))}
                                  </div>
                                )}

                                {!m.detalles?.cuotas?.length && !m.detalles?.descuentos?.length && (
                                  <p className="text-muted small mb-0">Sin detalles disponibles</p>
                                )}
                              </div>
                            </div>
                          </div>
                        ))}
                      </div>
                    ) : (
                      <div className="text-center py-4 text-muted small">
                        Aún no hay registros para este socio
                      </div>
                    )}
                  </div>
                </div>
              )}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}